<template>
  <div>
    <template v-if="uid">
      <navigation></navigation>
      <v-content>
        <router-view></router-view>
        <!-- <basic-data
          v-if="recabarDatos"
          :usuario1="usuarioComb"
          :pantalla="pantalla"
          :dataModel="data"
        ></basic-data> -->
      </v-content>
      <v-footer color="blue lighten-1" app>
        <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
      </v-footer>
    </template>
    <template v-else>
      <Login />
    </template>
  </div>
</template>

<script>
import Navigation from "@/components/modules/navigation";
import Login from "@/components/login";
// import BasicData from "./basic-data";

import { mapGetters, mapActions } from "vuex";
export default {
  name: "Propietario",
  components: {
    Navigation,
    Login
    // BasicData
  },
  data() {
    return {
      vista: "expedientes",
      pantalla: [
        ["nombre", "apellidos"],
        ["calle", "cp", "localidad", "provincia"],
        ["nif", "tlf", "fechaNacimiento"]
      ],
      data: {
        nombre: null,
        apellido1: null,
        apellido2: null,
        nif: null,
        tlf: [],
        fechaNacimiento: null,
        direccion: {
          calle: null,
          cp: null,
          localidad: null,
          provincia: null
        }
      }
    };
  },
  mounted() {
    if (this.recabarDatos) {
      this.$router.push("/usuario/home")
    }
  },
  created() {
    // this.setUsuario();
    this.setPropietario();
    this.setProvincias();
    this.setComunidades();
    // this.setExpedientesStatus();
  },
  watch: {
    uid(newValue) {
      this.setPropietario();
    }
  },
  methods: {
    ...mapActions([
      "setUsuario",
      "setPropietario",
      "setExpedientesStatus",
      "setProvincias",
      "setComunidades"
    ])
  },
  computed: {
    ...mapGetters(["propietario", "level", "getUserUid"]),
    usuarioComb() {
      return JSON.parse(
        JSON.stringify(Object.assign({}, this.usuario, this.data))
      );
    },
    recabarDatos() {
      if (this.usuario === "sin datos") {
        return true;
      } else {
        let datos = []
        for (let index = 0; index < this.pantalla.length; index++) {
          for (let i = 0; i < this.pantalla[index].length; i++) {
            const element = this.pantalla[index][i];
            if (!this.data[element]) {
              // return true;
              datos.push(element);
            }
          }
        }
        return datos.length < 1 ? false : datos;
      }
    },
    usuario() {
      return this.propietario;
    },
    uid() {
      return this.getUserUid;
    }
  }
};
</script>
